'use strict';

angular.module('far.models.userSendings', [])
    .service('userSendings', function ($log, $http, $filter) {

        this.get = function (routeId, callback) {

            var route = new UserSendings();

            $http.get(Routing.generate('api_entities_get_user_sendings', {user: routeId}))
                .then(function (response) {
                    route.update(response.data);

                    if (typeof callback == 'function') {
                        callback(route);
                    }

                }, function errorCallback(response) {
                    $log.error(response);
                });

            return route;
        };

        class UserSendings {

            constructor(userData = null)
            {
                this.id = null;
                this.is_member_card_received = false;
                this.is_member_card_sent = false;
                this.member_card_and_sticker_request_enabled = false;
                this.sticker_request_enabled = false;
                this.member_card_received = null;
                this.member_card_sent = null;
                this.send_member_card_and_sticker = false;
                this.send_sticker = false;

                if (userData) {
                    this.update(userData);
                }
            }

            update(userData)
            {
                var self = this;

                angular.merge(self, userData);

                if (userData.hasOwnProperty('member_card_sent')) {
                    self.member_card_sent = userData.member_card_sent ? $filter('date')(new Date(userData.member_card_sent), 'dd.MM.yyyy') : null;
                    self.is_member_card_sent = userData.member_card_sent ? true : false;
                }

                if (userData.hasOwnProperty('member_card_received')) {
                    self.is_member_card_received = userData.member_card_received ? true : false;
                }

                if (this.is_member_card_received || this.send_member_card_and_sticker) {
                    this.member_card_and_sticker_request_enabled = false;
                } else {
                    this.member_card_and_sticker_request_enabled = true;
                }

                this.sticker_request_enabled = !this.send_sticker;

                return this;
            }

            saveSendMemberCardAndSticker(callback)
            {
                var self = this;
                $http.patch(Routing.generate('api_entities_patch_user_send_member_card_and_sticker', {user : this.id }), {
                    send_member_card_and_sticker : self.send_member_card_and_sticker
                }).then(function(response) {
                    self.update(response.data);
                    if (typeof callback == 'function') {
                        callback(self);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
            }

            saveSendSticker(callback)
            {
                var self = this;
                $http.patch(Routing.generate('api_entities_patch_user_send_sticker', {user : this.id }), {
                    send_sticker : self.send_sticker
                }).then(function(response) {
                    self.update(response.data);
                    if (typeof callback == 'function') {
                        callback(self);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
            }

            saveMemberCardSent(callback)
            {
                var self = this;
                $http.patch(Routing.generate('api_entities_patch_user_member_card_sent', {user : this.id }), {
                    is_member_card_sent : self.is_member_card_sent
                }).then(function(response) {
                    self.update(response.data);
                    if (typeof callback == 'function') {
                        callback(self);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
            }

            saveMemberCardReceived(callback)
            {
                var self = this;
                $http.patch(Routing.generate('api_entities_patch_user_member_card_received', {user : this.id }), {
                    is_member_card_received : self.is_member_card_received
                }).then(function(response) {
                    self.update(response.data);
                    if (typeof callback == 'function') {
                        callback(self);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
            };


        }






    });
